<template>
  <div class="jzliu-bi-engine-dws-table">
    <el-table class="table-header-gray" :data="tableData" style="width: 100%" :max-height="tableHeight">
      <el-table-column
        show-overflow-tooltip
        min-width="180"
        v-for="item in columns"
        :prop="item.prop"
        :label="item.label"
      />
    </el-table>
    <el-pagination
      style="margin-top: 10px"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryList.pageNum"
      :page-size="queryList.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="queryList.total"
    >
    </el-pagination>
  </div>
</template>

<script>
import { getCategoryDimension } from "../../../utils/index";
export default {
  name: "chartDataTable",
  props: {
    selectItem: {
      type: Object,
      default: () => {
        return {};
      },
    },
    data: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      columns: [],
      queryList: {
        pageNum: 1,
        pageSize: 10,
        total: 0,
      },
    };
  },
  computed: {
    tableData() {
      const data = this.data || [];
      if (!data || data.length === 0) {
        return [];
      }
      const { displayRows } = getCategoryDimension(this.selectItem.fields);
      this.columns = displayRows.map((item) => {
        return {
          prop: item.unitCode,
          label: item.name,
        };
      });
      this.queryList.total = data.length;
      return data.slice(
        (this.queryList.pageNum - 1) * this.queryList.pageSize,
        this.queryList.pageNum * this.queryList.pageSize
      );
    },
    tableHeight() {
      return window.innerHeight - 200;
    },
  },
  methods: {
    handleSortChange(column) {
      column.chartType = "chart";
      this.$emit("sort-change", column);
    },
    handleSizeChange(size) {
      this.queryList.pageSize = size;
      this.queryList.pageNum = 1;
    },
    handleCurrentChange(page) {
      this.queryList.pageNum = page;
    },
  },
};
</script>

<style scoped lang="less"></style>
